import React from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

const CapabilitySection = ({ features }) => {
  if (!features || features.length === 0) return null;

  return (
    <section className="py-6 lg:py-8 ">
      <div className="max-w-[1700px] mx-auto px-6 sm:px-8 lg:px-10 xl:px-12">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          viewport={{ once: true }}
          className="mb-8"
        >
          {/* Badge */}
          <div className="inline-flex items-center rounded-full bg-gradient-to-r from-orange-100 via-pink-100 to-purple-100 px-3 py-1.5 text-[11px] sm:text-xs font-semibold uppercase tracking-wide text-orange-600">
            What We Offer
          </div>

          {/* Heading */}
          <h2 className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight text-gray-900">
            Key Capabilities
          </h2>

          {/* Divider */}
          <div className="mt-3 h-[3px] w-16 rounded-full bg-gradient-to-r from-[#FF7A18] via-[#EC4899] to-[#8B5CF6]" />

          {/* Description */}
          <p className="mt-5 max-w-5xl text-[15px] sm:text-base leading-7 text-gray-600">
            Our AI-powered capabilities help organizations automate workflows,
            improve operational efficiency, and accelerate digital
            transformation with intelligent solutions.
          </p>
        </motion.div>

        {/* Capability Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-5">
          {features.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.4,
                delay: index * 0.08,
              }}
              viewport={{ once: true }}
              whileHover={{ y: -3 }}
              className="group rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition-all duration-300 hover:border-[#EC4899]/40 hover:shadow-md"
            >
              {/* Icon */}
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-orange-100 via-pink-100 to-purple-100 transition-transform duration-300 group-hover:scale-105">
                <Sparkles
                  size={18}
                  className="text-[#EC4899]"
                />
              </div>

              {/* Title */}
              <h3 className="mt-4 text-lg font-semibold text-gray-900 transition-colors duration-300 group-hover:text-[#EC4899]">
                {item.title}
              </h3>

              {/* Description */}
              <p className="mt-3 text-[14px] sm:text-[15px] leading-6 text-gray-600">
                {item.desc}
              </p>

              {/* Bottom Accent */}
              <div className="mt-4 h-[3px] w-10 rounded-full bg-gradient-to-r from-[#FF7A18] via-[#EC4899] to-[#8B5CF6] transition-all duration-300 group-hover:w-16" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CapabilitySection;